import { Tooltip } from "@mui/material";
import { NavLink } from "react-router-dom";
import GradientIcon from "../Custom/GradientIcon";

const CustomLink = ({
  urlTo,
  title,
  tooltipDisabled,
  hidePTag,
  children,
  iconComponent,
  rotate,
}) => {
  return (
    <NavLink to={urlTo} className="nav-link">
      {({ isActive }) => (
        <>
          <Tooltip title={title} placement="right" disabled={tooltipDisabled}>
            {isActive ? (
              <GradientIcon
                IconComponent={iconComponent}
                className="icon"
                style={{
                  transform: rotate ? "rotate(90deg)" : "none",
                }}
              />
            ) : (
              children
            )}
          </Tooltip>
          <p hidden={hidePTag} className="description">
            {title}
          </p>
        </>
      )}
    </NavLink>
  );
};

export default CustomLink;
